'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitAddCreditCard = exports.getUiAddCreditCard = exports.ADD_CREDIT_CARD_SUCCESS = exports.ADD_CREDIT_CARD_REQUEST = exports.ADD_CREDIT_CARD_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = require('./user');

var _api = require('../api');

var _reselect = require('reselect');

var _modal = require('./modal');

var _config = require('./config');

var _getStripeErrorMessageFromResponse = require('../../utils/getStripeErrorMessageFromResponse');

var _getStripeErrorMessageFromResponse2 = _interopRequireDefault(_getStripeErrorMessageFromResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var ADD_CREDIT_CARD_FAIL = exports.ADD_CREDIT_CARD_FAIL = 'la/ui/addCreditCard/FAIL';
var ADD_CREDIT_CARD_REQUEST = exports.ADD_CREDIT_CARD_REQUEST = 'la/ui/addCreditCard/REQUEST';
var ADD_CREDIT_CARD_SUCCESS = exports.ADD_CREDIT_CARD_SUCCESS = 'la/ui/addCreditCard/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case ADD_CREDIT_CARD_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: null,
                submitted: true,
                success: false
            });
        case ADD_CREDIT_CARD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case ADD_CREDIT_CARD_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: (0, _getStripeErrorMessageFromResponse2.default)(action.payload),
                submitted: false,
                success: false
            });
        case _modal.DISMISS_MODAL:
            return DEFAULT_STATE;
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.addCreditCard;
};

var getUiAddCreditCard = exports.getUiAddCreditCard = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitAddCreditCard = exports.submitAddCreditCard = function submitAddCreditCard(_ref) {
    var cardToken = _ref.cardToken;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, bidderId, deployment, isStripeCustomer, apiCall, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            bidderId = (0, _user.getBidderId)(state);
                            deployment = (0, _config.getDeployment)(state);
                            isStripeCustomer = (0, _user.getIsStripeCustomer)(state);


                            dispatch({
                                payload: bidderId,
                                type: ADD_CREDIT_CARD_REQUEST
                            });

                            apiCall = isStripeCustomer ? _api.Auth.putAddCreditCard : _api.Auth.postAddCreditCard;
                            _context.next = 10;
                            return apiCall({ authToken: authToken, bidderId: bidderId, cardToken: cardToken, deployment: deployment });

                        case 10:
                            response = _context.sent;
                            _context.next = 13;
                            return dispatch((0, _user.fetchBidderDataIfNeeded)(authToken, true));

                        case 13:

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: ADD_CREDIT_CARD_SUCCESS
                            });
                            _context.next = 20;
                            break;

                        case 16:
                            _context.prev = 16;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: ADD_CREDIT_CARD_FAIL
                            });
                            throw _context.t0;

                        case 20:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 16]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/addCreditCard.js
// module id = ML/9
// module chunks = 60